import { reportAccessFailure } from './reportAccessFailure';

const PROD_HOSTS = new Set(['prairi.com', 'www.prairi.com']);
const STAGING_HOSTS = new Set(['prairi2026.web.app', 'prairi2026.firebaseapp.com']);

const PROD_PROJECT_ID = 'prairi-prod-fe3a4';

/**
 * Alert admins when production hosting serves the wrong Firebase project (or vice versa).
 * Catches incidents like manual staging deploys to prairi.com where login breaks for everyone.
 */
export function reportFirebaseConfigMismatchIfNeeded(): void {
  const { hostname, pathname } = window.location;
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;

  if (!projectId || hostname === 'localhost' || hostname === '127.0.0.1') {
    return;
  }

  if (PROD_HOSTS.has(hostname) && projectId !== PROD_PROJECT_ID) {
    reportAccessFailure({
      kind: 'firebase_config_mismatch',
      route: pathname || '/',
      message: `Production host "${hostname}" is using Firebase project "${projectId}" (expected "${PROD_PROJECT_ID}"). Users cannot log in reliably.`,
    });
    return;
  }

  if (STAGING_HOSTS.has(hostname) && projectId === PROD_PROJECT_ID) {
    reportAccessFailure({
      kind: 'firebase_config_mismatch',
      route: pathname || '/',
      message: `Staging host "${hostname}" is using production Firebase project "${projectId}".`,
    });
  }
}
